import React, { useEffect, useState } from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { EditOfferForm } from "../../UI/Offer/Edit/EditOfferForm";
import { useParams } from "react-router-dom";
import { api_Routes } from "../../tools/api_Routes";
import { Helper } from "../../tools/Helper";
import { CircularProgress, LinearProgress } from "@mui/material";

const OfferEdit = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState();
  const [services, setServices] = useState();

  const getServices = async () => {
    const { response } = await Helper.Get({
      url: api_Routes.Services.View,
      hasToken: true,
    });
    if (response) {
      setServices(response?.data);
    }
  };

  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Offers.GetOne}${id}`,
      });

      if (response) {
        setData(response?.data);
        await getServices();
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Edit Offer <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Edit offer: {data?.title}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress />
          ) : (
            <EditOfferForm data={data} setData={setData} services={services} />
          )
        }
      />
    </div>
  );
};

export default React.memo(OfferEdit);
